<template>
  <div class="tree-warp">
    <div class="tree-warp_container">
      <div class="tree-warp_left">
        <ul>
          <li
            v-for="(item, index) in leftData"
            :key="index"
            class="border-1px"
            @click="chooseClick(item.id)"
            :class="{ activeLi: item.id == currentId }"
          >
            {{ item.label }}
            <b v-if="selectData[item.id] && selectData[item.id].length"></b>
          </li>
        </ul>
      </div>
      <div class="tree-warp_content">
        <ul>
          <li v-if="currentId !== 'all'">
            <rich-checkbox
              position="right"
              :option="'notAll'"
              @input="checkAll"
              v-model="allChecked"
            >
              全选
            </rich-checkbox>
          </li>
        </ul>
        <rich-checkbox-group v-model="selectId" @input="checkboxChange">
          <ul>
            <li
              v-for="(item, index) in rightData"
              :key="index"
              class="border-1px"
            >
              <rich-checkbox :option="item.id" position="right">
                {{ item.label }}
              </rich-checkbox>
            </li>
          </ul>
        </rich-checkbox-group>
      </div>
    </div>
  </div>
</template>

<script>
import i18nVue from '@/i18n/locale'
export default {
  name: 'treeSelect',
  props: {
    value: {
      default: () => [],
      type: Array
    },
    options: {
      default: () => [],
      type: Array
    }
  },
  data() {
    return {
      leftData: [
        {
          label: i18nVue.t('Gattaran_mgt_All_SSzR' /** 全部 */),
          id: 'all'
        }
      ],
      currentId: 'all',
      selectData: {},
      allChecked: false,
      selectId: []
    }
  },
  created() {
    this.init()
    this.initWithOption() // 初始化传入的数据
  },
  watch: {
    rightData: {
      deep: true,
      handler(v) {
        if (v.every(({ checked }) => checked)) {
          this.allChecked = ['notAll']
        } else {
          this.allChecked = false
        }
      }
    },
    selectId(v) {
      if (v.includes('allChild')) {
        for (let i in this.selectData) {
          if (i !== 'all') {
            this.selectData[i] = []
            this.inputValue(1)
          }
        }
      }
      if (v.length < this.rightData.length) {
        this.allChecked = false
      } else if ((v.length = this.rightData.length)) {
        this.allChecked = 'notAll'
      } else {
        this.allChecked = false
      }
    },
    currentId(v) {
      this.selectId = this.selectData[v] || []
      if (v !== 'all') {
        if (this.rightData.every(({ checked }) => checked)) {
          this.selectId.push('notAll')
        } else {
          this.allChecked = false
        }
      }
    },
    value(v) {
      console.log(v, 'vvvvvvvvv')
      if (v.length === 0) this.selectId = []
    }
  },
  computed: {
    rightData: {
      get() {
        if (this.currentId === 'all') {
          return [
            {
              id: 'allChild',
              label: i18nVue.t('Gattaran_mgt_All_SSzR' /** 全部 */)
            }
          ]
        }
        return this.tabData.find(({ id }) => id === this.currentId).children
      },
      set() {}
    }
  },
  methods: {
    inputValue(e) {
      this.$emit('input', this.expandTree(e))
    },
    expandTree(e) {
      if (!e) {
        let obj = []
        for (let i in this.selectData) {
          if (i !== 'all') {
            obj = obj.concat(this.selectData[i])
          }
        }
        return obj.filter((v) => v !== 'notAll')
      } else {
        let arr = []
        this.tabData.forEach((item) => {
          arr = arr.concat(item.children.map((item) => item.id))
        })
        return arr
      }
    },
    initWithOption() {
      if (this.value.length === 0) this.selectId = []
      if (this.value.length === 1 && this.value[0] === 'allChild') {
        this.selectId = this.value
      } else {
        this.value.forEach((item) => {
          this.tabData.forEach((inside) => {
            const row = inside.children.find((v) => v.id === item)
            if (row) {
              if (this.selectData[inside.id]) {
                this.selectData[inside.id].push(item)
              } else {
                this.selectData[inside.id] = [item]
              }
            }
          })
        })
      }
    },
    init() {
      const response = this.options.map((item) => {
        this.leftData.push(item)
        return item
      })
      this.tabData = response
    },
    getLeftData() {
      this.options.map((item) => {})
    },
    checkAll(v) {
      if (v) {
        this.selectId = this.rightData.map((item) => item.id).concat(['notAll'])
        this.selectData[this.currentId] = this.selectId
        delete this.selectData['all']
      } else {
        this.selectId = []
        this.selectData[this.currentId] = this.selectId
      }
      this.inputValue()
    },
    checkboxChange(v) {
      this.selectData[this.currentId] = v
      if (v[0] !== 'allChild' && v.length) {
        delete this.selectData.all
      }
      if (v[0] !== 'allChild') {
        this.inputValue()
      }
    },
    allChange() {},
    getRightData(currentId) {
      this.currentId = currentId
    },
    prepend(arr, item) {
      var newArr = arr.slice(0)
      newArr.unshift(item)
      return newArr
    },

    chooseClick(currentId) {
      this.getRightData(currentId)
    }
  }
}
</script>

<style scoped lang="scss">
.tree-warp {
  .tree-warp_container {
    display: flex;
    height: calc(100vh - 410px);
    overflow-y: auto;
    .tree-warp_left {
      background: #f8f8fa;
      ul {
        li {
          width: 221px;
          font-family: DiDiSans-Pro-Regular;
          font-size: 28px;
          color: #282b33;
          padding: 36px 20px;
          font-weight: normal;
          box-sizing: border-box;
          line-height: 40px;
          position: relative;
          &.activeLi {
            font-family: DiDiSans-Pro-Medium;
            color: #ff7a45;
            background-color: #fff;
            position: relative;
            padding-left: 14px;
            border-left: 6px solid #ff7a45;
          }
        }
        b {
          display: block;
          position: absolute;
          right: 24px;
          top: 24px;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: #ff801f;
        }
      }
    }
  }
  &_content {
    background-color: white;
    width: calc(100vw - 221px);
    ul {
      margin-left: 39px;
      margin-right: 20px;
      li {
        padding: 36px 0;
        box-sizing: border-box;
        position: relative;
        .rich-checkbox {
          padding: 0;
          ::v-deep .rich-checkbox-wrap {
            padding: 0;
            line-height: normal;
          }
          .rich-checkbox-ui {
            margin: 0;
          }
          ::v-deep .rich-checkbox-text {
            font-family: DiDiSans-Pro-Medium;
            font-size: 32px;
            color: #303133;
            letter-spacing: 0;
            line-height: 40px;
            font-weight: normal;
          }
        }
      }
    }
  }
  .border-1px:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 200%;
    height: 200%;
    border-bottom: 1px solid #dadbe0;
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
    transform-origin: top left;
  }
}
</style>
